import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type SubmitGiftVoucherPorschePaymentMutation,
    type SubmitGiftVoucherPorschePaymentMutationVariables,
    SubmitGiftVoucherPorschePaymentDocument,
} from '../../../../../api/mutations/submitGiftVoucherPorschePayment';
import { type AgreementValues } from '../../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';
import { type PaymentData } from '../../../StandardApplicationEntrypoint/PorschePaymentPage/PorschePaymentWidget';
import { type PorschePaymentFormValues } from './Inner';

// calls porsche submit payment api
// this calls the manage transactions of porsche
export const submitPayment = async (
    data: PaymentData,
    agreements: AgreementValues,
    token: string,
    promoCodeId?: string
) => {
    const response = await fetch('/api/porsche/submitGiftVoucherPayment', {
        method: 'POST',
        body: JSON.stringify({
            token,
            ...data,
            promoCodeId,
            agreedConsents: Object.entries(agreements)
                .filter(Boolean)
                .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null)),
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response.json();
};

// porsche deposit submission calls the application journey
const useGiftVoucherPorscheDepositSubmission = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: PorschePaymentFormValues, skipDeposit: boolean) => {
            const { promoCodeId, ...agreementValues } = values;
            const { data } = await apolloClient.mutate<
                SubmitGiftVoucherPorschePaymentMutation,
                SubmitGiftVoucherPorschePaymentMutationVariables
            >({
                mutation: SubmitGiftVoucherPorschePaymentDocument,
                variables: {
                    token,
                    agreedConsents: Object.entries(agreementValues)
                        .filter(Boolean)
                        .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null))
                        .filter(Boolean),
                    skipDeposit,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useGiftVoucherPorscheDepositSubmission;
